function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M148.5,212.002c-5.458,0-9.884,4.425-9.884,9.883v32.616c0,5.458,4.426,9.884,9.884,9.884c5.458,0,9.884-4.426,9.884-9.884 v-32.616C158.384,216.427,153.958,212.002,148.5,212.002z"
}), React.createElement("path", {
  d: "M104.922,220.55c-0.737-5.408-5.71-9.194-11.129-8.457c-5.408,0.737-9.194,5.72-8.457,11.128l4.448,32.616 c0.675,4.955,4.914,8.549,9.78,8.549c0.444,0,0.895-0.03,1.348-0.092c5.408-0.737,9.194-5.72,8.457-11.129L104.922,220.55z"
}), React.createElement("path", {
  d: "M203.207,212.093c-5.414-0.739-10.392,3.05-11.129,8.457l-4.447,32.615c-0.737,5.409,3.049,10.392,8.457,11.129 c0.453,0.062,0.903,0.092,1.348,0.092c4.866,0,9.105-3.595,9.78-8.549l4.448-32.616 C212.401,217.813,208.615,212.83,203.207,212.093z"
}), React.createElement("path", {
  d: "M289.359,156.654c0-30.362-15.107-62.087-41.448-87.04c-16.82-15.936-36.479-27.493-57.5-34.118 C187.061,15.383,169.548,0,148.5,0s-38.562,15.383-41.911,35.496c-21.021,6.625-40.68,18.183-57.5,34.118 c-26.342,24.953-41.448,56.678-41.448,87.04c0,18.932,12.597,35.007,29.942,40.486l7.808,63.71 C47.835,280.784,66.161,297,86.241,297h124.518c20.08,0,38.406-16.216,40.851-36.149l7.793-63.588 C276.733,191.898,289.359,175.725,289.359,156.654z M148.5,19.767c12.535,0,22.732,10.197,22.732,22.732 c0,12.535-10.197,22.732-22.732,22.732s-22.732-10.197-22.732-22.732C125.768,29.964,135.965,19.767,148.5,19.767z  M231.989,258.445c-1.249,10.184-10.972,18.788-21.23,18.788H86.241c-10.259,0-19.981-8.604-21.23-18.788l-7.338-59.877 c10.252-1.711,19.274-7.102,25.654-14.768c7.897,9.375,19.791,15.353,33.07,15.353c13.01,0,24.664-5.946,32.419-15.281 c7.849,9.335,19.644,15.281,32.813,15.281c13.01,0,24.664-5.946,32.419-15.281c6.319,7.515,15.198,12.826,25.289,14.615 L231.989,258.445z M246.86,179.386c-12.676,0-22.989-10.197-22.989-22.731c0-5.459-4.425-9.884-9.883-9.884 c-5.458,0-9.884,4.425-9.884,9.884c0,12.534-10.082,22.731-22.476,22.731c-12.676,0-22.988-10.197-22.988-22.731 c0-5.459-4.426-9.884-9.884-9.884c-5.458,0-9.884,4.425-9.884,9.884c0,12.534-10.082,22.731-22.476,22.731 c-12.601,0-23.245-10.409-23.245-22.731c0-5.459-4.426-9.884-9.884-9.884c-5.458,0-9.884,4.425-9.884,9.884 c0,12.534-10.197,22.731-22.731,22.731c-12.601,0-23.246-10.409-23.246-22.731c0-24.592,13.188-51.766,35.276-72.689 c13.436-12.73,28.928-22.233,45.469-28.142c5.604,16.925,21.567,29.175,40.348,29.175s34.744-12.25,40.348-29.175 c16.542,5.908,32.032,15.411,45.469,28.142c22.089,20.924,35.276,48.098,35.276,72.689 C269.593,169.189,259.396,179.386,246.86,179.386z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgMuffin = function SvgMuffin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMuffin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/muffin.ec0120ea.svg";
export { ForwardRef as ReactComponent };